import { StyledLogoSlider } from './styles/LogoSlider.style';

export default function LogoSlider() {
	return (
		<StyledLogoSlider>
			{/* <div className='tech-slideshow'>
				<div className='mover-1'></div>
				<div className='mover-2'></div>
			</div> */}

			<section className='hm-clients'>
				<div className='swui-container'>
					<h4 className='swui-h4 hm-clients__title'>CREDENTIALS</h4>
				</div>
				<div className='hm-clients__logos'>
					<div className='hm-clients__track' style={{ width: '1283px' }}>
						<div className='hm-clients__logo' style={{ width: '126px' }}>
							<img
								className='hm-clients__image hm-clients__image'
								src='./images/Hu-logo.jpg'
								alt='Hawassa University'
							/>
						</div>
						<div className='hm-clients__logo' style={{ width: '162px' }}>
							<img
								className='hm-clients__image hm-clients__image'
								src='./images/siteground.png'
								alt='Google'
							/>
						</div>
						<div className='hm-clients__logo' style={{ width: '300px' }}>
							<img
								className='hm-clients__image hm-clients__image'
								src='./images/TAC-logo.png'
								alt='Google'
							/>
						</div>
						<div className='hm-clients__logo' style={{ width: '200px' }}>
							<img
								className='hm-clients__image hm-clients__image'
								src='./images/Cree-logo.png'
								alt='Google'
							/>
						</div>
						<div className='hm-clients__logo' style={{ width: '180px' }}>
							<img
								className='hm-clients__image hm-clients__image'
								src='./images/tamrin.png'
								alt='Google'
							/>
						</div>
						<div className='hm-clients__logo' style={{ width: '125px' }}>
							<img
								className='hm-clients__image hm-clients__image'
								src='./images/jks-karate-et.jpg'
								alt='Google'
							/>
						</div>
						<div className='hm-clients__logo' style={{ width: '190px' }}>
							<img
								className='hm-clients__image hm-clients__image'
								src='./images/grail-logo.jpg'
								alt='Grail Consulting Services'
							/>
						</div>
					</div>
				</div>{' '}
			</section>
		</StyledLogoSlider>
	);
}
